import { z } from 'zod';

export const RoleTypeSchema = z.union([
    z.literal('operator'),
    z.literal('constructionManager'),
    z.literal('manager'),
    z.literal('driver'),
    z.literal('machinist'),
    z.literal('groundskeeper'),
    z.literal('supervisor'),
    z.literal('projectManager'),
    z.literal('advisor'),
    z.literal('sales'),
    z.literal('scaleOperator'),
    z.literal('other'),
]);

export const CONTACT_PERSON_ROLES_LABEL = {
    operator: 'contactPerson.panel.roles.operator',
    constructionManager: 'contactPerson.panel.roles.constructionManager',
    manager: 'contactPerson.panel.roles.manager',
    driver: 'contactPerson.panel.roles.driver',
    machinist: 'contactPerson.panel.roles.machinist',
    groundskeeper: 'contactPerson.panel.roles.groundskeeper',
    supervisor: 'contactPerson.panel.roles.supervisor',
    projectManager: 'contactPerson.panel.roles.projectManager',
    advisor: 'contactPerson.panel.roles.advisor',
    sales: 'contactPerson.panel.roles.sales',
    scaleOperator: 'contactPerson.panel.roles.scaleOperator',
    other: 'contactPerson.panel.roles.other',
} as const satisfies Record<RoleType, string>;

export const RoleSchema = z.object({
    value: RoleTypeSchema,
});

export type Role = z.infer<typeof RoleSchema>;
export type RoleType = z.infer<typeof RoleTypeSchema>;
